import { isOfflineFailure } from '../offline'
import { serializeError } from '@w/utils'
import type { TelErrorData } from '../tel-error-data'
import type { SpanData } from '../tel-types'

export function prepareTelError({
  error,
  span,
  levelOverride,
}: {
  error: unknown
  span: SpanData
  levelOverride?: 'warning' | 'error'
}): TelErrorData {
  if (error === undefined) throw new Error('Error is undefined')

  const serialized = serializeError(error)
  // INV-TEL-CANCEL: expected aborts and HTTP 4xx default to warnings. INV-TEL-OFFLINE (../offline.ts): so does an
  // offline transport answer.
  // Read the producer contract: serialization can omit subclass HTTP fields.
  const source = typeof error === 'object' && error !== null ? error : serialized
  const status = 'status' in source ? source.status
    : 'statusCode' in source ? source.statusCode : undefined
  const aborted = 'name' in source && source.name === 'AbortError'
  const level = aborted || typeof status === 'number' && status >= 400 && status < 500 || isOfflineFailure(error)
    ? 'warning' : 'error'

  const result: TelErrorData = {
    error: serialized,
    origin: span.origin ?? 'client',
    level: levelOverride ?? level,
  } as TelErrorData

  if (span) {
    result.traceId = span.traceId
    result.spanId = span.id
    result.requestId = span.requestId
  }

  return result
}
